import React from 'react';

import Button from '../../Button/Button';

export interface VerificationButtonsProps {
  onVerify: () => void;
  onSkip?: () => void;
  showSkipButton?: boolean;
  isVerifyDisabled: boolean;
  isLoading: boolean;
}

const VerificationButtons: React.FC<VerificationButtonsProps> = ({
  onVerify,
  onSkip,
  showSkipButton,
  isVerifyDisabled,
  isLoading
}) => {
  if (showSkipButton && onSkip) {
    return (
      <div className="flex justify-center">
        <div className="flex gap-3 w-[334px]">
          <Button
            type="submit"
            onClick={onVerify}
            disabled={isVerifyDisabled}
            isLoading={isLoading}
            className="flex-1"
          >
            Verify
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onSkip}
            disabled={isLoading}
            className="flex-1"
          >
            Skip for now
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <Button
        type="button"
        onClick={onVerify}
        disabled={isVerifyDisabled}
        isLoading={isLoading}
        className="w-[334px]"
      >
        Verify
      </Button>
    </div>
  );
};

export default VerificationButtons;

